/**
 * bundle-stamp.js  (v6.1 — exposes window.__bundleStampOpen for non-native triggers)
 * -------------------------------------------------------------
 * On each "Add to cart":
 *   1. Groups the NVR + its drives under one _bundle_id (NVR=parent, drives=addon).
 *   2. CAPS total hard-drive quantity in the /cart/add payload to the NVR's
 *      bay limit, so the cart can never receive more drives than bays — even
 *      if the SpiceGems on-page selector shows more.
 *
 * Reads window.__NVR_BAY (set by main-product.liquid):
 *   { limit: <bays, 0 = no limit>, hddIds: { "<variantId>": true, ... } }
 *
 * v6.1: openBundleWindow() is published as window.__bundleStampOpen so callers
 *       whose element matches NONE of the click/submit selectors below (e.g. the
 *       OBW duplicate Add-to-cart button: type="button", class "obw-buy-dup")
 *       can open a bundle window themselves before writing the NVR + drive.
 *       Without this, those writes go through UNSTAMPED and the drive lands as a
 *       standalone line instead of nested under the NVR.
 *
 * Set DEBUG = false once confirmed.
 * PLACEMENT: high in <head> of theme.liquid, WITHOUT defer, before app scripts.
 */
(function () {
  'use strict';

  var DEBUG = true;
  var BUNDLE_WINDOW_MS = 3000;

  var activeBundleId = null;
  var activeParentId = null;
  var activeBayLimit = 0;     // bays for the NVR in this burst (0 = no limit)
  var activeHddIds = {};      // variant ids that are hard drives
  var activeParentTitle = '';  // the NVR's product title, for _paired_with on drives
  var bundleHddCount = 0;     // running total of drives stamped in this window
  var suppressAdd = false;    // true => this single-item add is over the bay limit, skip it
  var windowTimer = null;

  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ['[bundle-stamp]'].concat([].slice.call(arguments)));
    }
  }

  function newBundleId() {
    return 'nvr-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
  }

  function pageHasAddons() {
    return !!document.querySelector(
      '.spice-spa-addon-product-item, [class*="spice-spa"], [class*="spice_spa"], [id*="spice"]'
    );
  }

  function readMainVariantId() {
    var input =
      document.querySelector('product-form form [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      (document.querySelector('[id^="product-form-"]') &&
        document.querySelector('[id^="product-form-"] [name="id"]'));
    return input ? String(input.value || '') : '';
  }

  function readBayConfig() {
    var cfg = window.__NVR_BAY || {};
    activeBayLimit = parseInt(cfg.limit, 10) || 0;
    activeHddIds = cfg.hddIds || {};
    activeParentTitle = cfg.title || '';
  }

  function openBundleWindow() {
    if (!pageHasAddons()) return;

    if (!activeBundleId) {
      activeBundleId = newBundleId();
      activeParentId = readMainVariantId();
      readBayConfig();
      bundleHddCount = 0;
      log('window OPEN. id =', activeBundleId, '| NVR variant =', activeParentId, '| bay limit =', activeBayLimit);
    } else {
      if (!activeParentId) activeParentId = readMainVariantId();
      log('window reused. id =', activeBundleId);
    }

    clearTimeout(windowTimer);
    windowTimer = setTimeout(function () {
      log('window closed:', activeBundleId);
      activeBundleId = null;
      activeParentId = null;
      activeBayLimit = 0;
      activeHddIds = {};
      activeParentTitle = '';
      bundleHddCount = 0;
    }, BUNDLE_WINDOW_MS);
  }

  // Publish the opener so non-native triggers can open a window before they
  // fetch. The OBW duplicate button (type="button", class "obw-buy-dup") matches
  // none of the click/submit selectors below, so it calls this explicitly.
  window.__bundleStampOpen = openBundleWindow;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      '[name="add"], .product-form__submit, button[type="submit"], ' +
      '[class*="spice"][class*="add"], [class*="add-to-cart"], [class*="add_to_cart"]'
    );
    if (btn) openBundleWindow();
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      openBundleWindow();
    }
  }, true);

  // ---- helpers ----
  function roleFor(variantId) {
    if (activeParentId && String(variantId) === activeParentId) return 'parent';
    return 'addon';
  }
  function isActiveHdd(variantId) {
    return !!activeHddIds[String(variantId).trim()];
  }

  // Cap a hard-drive item's quantity against the bays still available.
  // Returns the (possibly reduced) quantity; 0 means "drop it".
  function capHddQuantity(variantId, quantity) {
    if (!activeBayLimit || activeBayLimit < 1) return quantity; // no limit
    if (!isActiveHdd(variantId)) return quantity;               // not a drive
    var q = parseInt(quantity, 10) || 0;
    var allowed = Math.max(0, activeBayLimit - bundleHddCount);
    var capped = Math.min(q, allowed);
    bundleHddCount += capped;
    if (capped !== q) log('drive qty capped', q, '->', capped, '(bay limit', activeBayLimit + ')');
    return capped;
  }

  function stampOne(item) {
    item.properties = item.properties || {};
    if (!item.properties._bundle_id) {
      item.properties._bundle_id = activeBundleId;
      item.properties._bundle_role = item.id != null ? roleFor(item.id) : 'addon';
    }
    // Drives carry the NVR's name so the cart can show "Included with <NVR>"
    if (item.properties._bundle_role === 'addon' && activeParentTitle && !item.properties._paired_with) {
      item.properties._paired_with = activeParentTitle;
    }
  }

  function stampJsonParsed(data) {
    if (Array.isArray(data.items)) {
      data.items = data.items.filter(function (it) {
        stampOne(it);
        if (it.id != null && isActiveHdd(it.id)) {
          it.quantity = capHddQuantity(it.id, it.quantity);
          if (it.quantity <= 0) return false; // bays full — drop this drive
        }
        return true;
      });
    } else if (data.id != null) {
      stampOne(data);
      if (isActiveHdd(data.id)) {
        var capped = capHddQuantity(data.id, data.quantity);
        if (capped <= 0) { suppressAdd = true; data.quantity = 0; } // bays full -> drop
        else data.quantity = capped;
      }
    }
    return data;
  }

  function stampStringBody(text) {
    try {
      var data = JSON.parse(text);
      var out = JSON.stringify(stampJsonParsed(data));
      log('processed JSON body');
      return out;
    } catch (e) { /* not JSON */ }

    try {
      var params = new URLSearchParams(text);
      var idVal = params.get('id');
      if (!params.has('properties[_bundle_id]')) {
        params.append('properties[_bundle_id]', activeBundleId);
        var roleU = idVal != null ? roleFor(idVal) : 'addon';
        params.append('properties[_bundle_role]', roleU);
        if (roleU === 'addon' && activeParentTitle) {
          params.append('properties[_paired_with]', activeParentTitle);
        }
      }
      if (idVal != null && isActiveHdd(idVal)) {
        var capped = capHddQuantity(idVal, params.get('quantity') || 1);
        if (capped <= 0) { suppressAdd = true; params.set('quantity', '0'); }
        else params.set('quantity', String(capped));
      }
      log('processed urlencoded body');
      return params.toString();
    } catch (e2) {
      log('could not parse body, left untouched');
      return text;
    }
  }

  function stampFormData(fd) {
    var idVal = fd.get ? fd.get('id') : null;
    var already = false;
    fd.forEach(function (v, k) { if (k === 'properties[_bundle_id]') already = true; });
    if (!already) {
      fd.append('properties[_bundle_id]', activeBundleId);
      var roleF = idVal != null ? roleFor(idVal) : 'addon';
      fd.append('properties[_bundle_role]', roleF);
      if (roleF === 'addon' && activeParentTitle) {
        fd.append('properties[_paired_with]', activeParentTitle);
      }
    }
    if (idVal != null && isActiveHdd(idVal)) {
      var capped = capHddQuantity(idVal, fd.get('quantity') || 1);
      if (capped <= 0) { suppressAdd = true; fd.set('quantity', '0'); }
      else fd.set('quantity', String(capped));
    }
    log('processed FormData body');
    return fd;
  }

  function stampAnyBody(body) {
    suppressAdd = false;
    if (typeof body === 'string') return stampStringBody(body);
    if (body instanceof FormData) return stampFormData(body);
    if (body instanceof URLSearchParams) return stampStringBody(body.toString());
    log('unknown body type, left untouched');
    return body;
  }

  function isCartAdd(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  // ---- patch fetch ----
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url);
        if (activeBundleId && isCartAdd(url)) {
          if (init && init.body != null) {
            init.body = stampAnyBody(init.body);
            if (suppressAdd) {
              log('over bay limit — add suppressed');
              return Promise.resolve(new Response('{"items":[]}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
            }
          } else if (typeof Request !== 'undefined' && input instanceof Request) {
            log('fetch called with Request object — rebuilding');
            return input.clone().text().then(function (text) {
              var stamped = stampStringBody(text);
              if (suppressAdd) {
                log('over bay limit — add suppressed');
                return new Response('{"items":[]}', { status: 200, headers: { 'Content-Type': 'application/json' } });
              }
              var newReq = new Request(input, { body: stamped });
              return origFetch.call(window, newReq);
            });
          }
        }
      } catch (err) { log('fetch patch error (failing open):', err); }
      return origFetch.apply(this, arguments);
    };
  }

  // ---- patch XMLHttpRequest ----
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__bundleUrl = url;
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (activeBundleId && body != null && isCartAdd(this.__bundleUrl)) {
        log('XHR add detected');
        arguments[0] = stampAnyBody(body);
        if (suppressAdd) {
          log('over bay limit — XHR add suppressed');
          try { this.abort(); } catch (e) {}
          return;
        }
      }
    } catch (err) { log('XHR patch error (failing open):', err); }
    return origSend.apply(this, arguments);
  };

  log('bundle-stamp v6.1 loaded');
})();
